<template>
  <div>
    <v-container fluid class="pa-0">
      <v-card class="pa-3 ma-2 rounded-lg" elevation="2">

        <v-row no-gutters>
          <v-col cols="12" lg="3" class="my-0 py-0">
            <div class="d-flex align-center flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Vendor {{ this.$route.query.documentType }} Documents
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-7 card_documentsmain" no-gutters>
          <v-col
            v-for="(image, index) in images"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="4"
            class="d-flex align-center justify-center mb-4 card_documents"
          >
            <v-card class="pa-2" outlined>
              <v-img
                :src="image.urlPath"
                height="180px"
                width="360px"
                contain
                class="black-box"
                @click="openImage(image)"
              ></v-img>
              <v-card-title class="text-center">{{ camelToSpaced(image.photoField) }}</v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="images.length === 0" class="pl-5">No Documents Available</v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import constants from '@/utils/constants'

export default {
  name: 'VendorDocs',
  data () {
    return {
      images: [],
      isLoading: false
    }
  },
  async created () {
    this.getDocuments()
  },
  methods: {
    openImage (image) {
      const imageUrl = image.urlPath
      window.open(imageUrl, '_blank')
    },
    camelToSpaced (inputString) {
      if (inputString !== 'driverPhoto') {
        inputString = inputString.replace(/Photo$/, '')
      }
      let spacedString = inputString.replace(/([a-z])([A-Z])/g, '$1 $2')

      spacedString = spacedString.charAt(0).toUpperCase() + spacedString.slice(1)

      return spacedString
    },
    async getDocuments () {
      const { id, documentType } = this.$route.query
      const { vendorID } = this.$route.params
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vendors/${vendorID}/documents?id=${id}&documentType=${documentType}`)
        this.images = data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
        this.images = []
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style >
.container .card_documentsmain .card_documents{
  padding: 10px !important;
  margin-bottom: 0px!important;
}
.card_documentsmain .v-card__title.text-center{
  font-size: 16px;
    color: #424242;
    padding-bottom: 0px;
    justify-content: center;

}
</style>
